/* eslint-disable react-hooks/exhaustive-deps */
import { Badge, Button, Skeleton, Table } from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUsers } from "../../actions/users";
import { formatDate } from "../../utils/Utils";

const Customers = ({ currentUser }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const history = useNavigate();
  const data = useSelector((state) => state?.users);

  useEffect(() => {
    setLoading(true);
    dispatch(getUsers(currentUser.store, "CUSTOMER"));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const columns = [
    {
      key: 1,
      title: "Name",
      dataIndex: "name",
    },
    {
      key: 2,
      title: "Phone",
      dataIndex: "phone",
    },
    {
      key: 3,
      title: "Email",
      dataIndex: "email",
    },
    {
      key: 4,
      title: "Updated At",
      render: (_, record) => <p>{formatDate(record?.updatedAt)}</p>,
    },
    {
      key: 5,
      title: "Created At",
      render: (_, record) => <p>{formatDate(record?.createdAt)}</p>,
    },
  ];

  const onRowClick = (id) => {
    history(`/customer/${id}`);
  };

  return (
    <Dashboard title="Customers">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl m-0 font-bold">Customers</h2>
        <Button type="primary" href="/customer/new" htmlType="submit">
          Add Customer
        </Button>
      </div>
      <div className="bg-white shadow p-4 my-4">
        <Skeleton loading={loading}>
          <Table
            className="cursor-pointer"
            columns={columns}
            dataSource={data}
            scroll={{
              x: 1000,
            }}
            rowKey={(record) => record?._id}
            onRow={(record) => {
              return {
                onClick: () => {
                  onRowClick(record?._id);
                },
              };
            }}
          />
        </Skeleton>
      </div>
    </Dashboard>
  );
};

export default Customers;
